/* libs */
import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

/* components */
import SidebarTitle from "./SidebarTitle";
import SidebarSection from "./SidebarSection";
import UserHasPermission from "../../helpers/validation/userHasPermission";
import * as themeActions from "../../actions/themesActions";

const ThemeNav = props => {
	const {
		user,
		location,
		match: {
			params: { appKey, themeId },
		},
		themes: { themeNav, currentTheme, pickingThemeTemplate },
		themeActions: { pickingThemeTemplateFinished },
	} = props;

	const basePath = `/apps/${appKey}/themes/${themeId === "copy" ? `copy/${currentTheme.appId}` : themeId}`;
	const userIsFull = UserHasPermission(user, "full");

	const renderSidebarSection = ({ route, name }) => {
		const currentRoute = location.pathname.split("/").pop();
		const isViewRoute = (currentRoute === themeId && route === "pages") || currentRoute === route;
		return (
			<SidebarSection
				key={name}
				showCaret={isViewRoute ? true : false}
				gridPath={`${basePath}/${route}`}
				title={name}
			/>
		);
	};

	return (
		<div className="theme-nav">
			<SidebarTitle to={`/apps/${appKey}`} title="My Experiences" onClick={pickingThemeTemplateFinished} />
			{userIsFull && !pickingThemeTemplate && themeNav.map(nav => renderSidebarSection(nav))}
		</div>
	);
};

const mapDispatchToProps = dispatch => ({
	themeActions: bindActionCreators(themeActions, dispatch),
});

ThemeNav.propTypes = {
	experiences: PropTypes.object,
	experiencesActions: PropTypes.object,
	globalActions: PropTypes.object,
	match: PropTypes.object,
	themeNav: PropTypes.array,
	responsiveActions: PropTypes.object,
	user: PropTypes.object,
};

export default connect(
	null,
	mapDispatchToProps
)(ThemeNav);
